import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
export function StatsSection() {
  const {
    t
  } = useLanguage();
  const stats = [{
    value: '99.9%',
    label: t.stats.uptime,
    color: 'text-cyan'
  }, {
    value: '150+',
    label: t.stats.clients,
    color: 'text-magenta'
  }, {
    value: '<24h',
    label: t.stats.response,
    color: 'text-cyan'
  }, {
    value: '100%',
    label: t.stats.satisfaction,
    color: 'text-magenta'
  }];
  return <section className="py-20 bg-black/90 border-y border-white/5 relative" data-id="element-358">
      <div className="max-w-7xl mx-auto px-4" data-id="element-359">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-360">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="text-center group" data-id="element-361">
              <div className={`font-cyber text-4xl md:text-5xl font-bold mb-2 ${stat.color} group-hover:scale-110 transition-transform duration-300`} data-id="element-362">
                {stat.value}
              </div>
              <div className="text-xs font-medium text-gray-500 uppercase tracking-widest" data-id="element-363">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}